import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import mailClientAPI from "../api/mail-client-api";

function MailLoginRequired({ children, redirect = "/login" }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {

      // First check if token exists
      if (!mailClientAPI.isAuthenticated()) {
        setIsAuthenticated(false);
        setIsLoading(false);
        navigate(redirect);
        return;
      }

      try {
        // Verify token is still valid
        const response = await mailClientAPI.verify();
        // If verify succeeds, user is authenticated
        if (response && response.Output) {
          setIsAuthenticated(true);
        } else {
          // Invalid response, redirect to login
          setIsAuthenticated(false);
          navigate(redirect);
        }
      } catch (error) {
        // Check if it's a network error or actual auth error
        const isAuthError = error.response?.status === 401 || error.response?.status === 403;
        
        if (isAuthError) {
          // Token invalid or expired, redirect to login
          console.log("Authentication failed:", error.response?.data?.Output?.message || error.message);
          setIsAuthenticated(false);
          navigate(redirect);
        } else {
          // Network error or other issue - don't log out, just show error
          console.error("Error verifying token (network issue):", error);
          // Still allow access if token exists (might be temporary network issue)
          setIsAuthenticated(true);
        }
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, [navigate, redirect]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return null;
  }

  return <>{children}</>;
}

export default MailLoginRequired;

